import { useEffect, useState } from "react";
import {
  announce,
  getA11yAnnouncementMode,
  subscribeA11yAnnouncementMode,
  toggleA11yAnnouncementMode,
  A11Y_ANNOUNCEMENT_MODES,
} from "../helper/a11yAnnouncements";

export const useA11yAnnouncements = () => {
  const [mode, setMode] = useState(getA11yAnnouncementMode);

  useEffect(() => subscribeA11yAnnouncementMode(setMode), []);

  return {
    mode,
    isOn: mode !== A11Y_ANNOUNCEMENT_MODES.OFF,
    toggle: toggleA11yAnnouncementMode,
  };
};

export const useAnnounceWhen = (active, message, level = "normal") => {
  useEffect(() => {
    if (!active || !message) {
      return undefined;
    }
    announce(message, level);
    return undefined;
  }, [active, message, level]);
};
